import React, { FC } from 'react'
import styled from 'styled-components'
import { Fonts, Icon, SwitchTabs } from 'components/base-ui'
import SwitchLang, { SwitchLangThemeTypeEnum } from 'components/SwitchLang'
import color from 'styles/colors'
import useServiceType from 'hooks/buffet/useServiceType'
import { useTranslation } from 'react-i18next'
import { LineItemServiceTypeForBuffetEnum } from 'graphQL/dinein/generate/operations'

interface Props {
  image: string
  tableName: string
  packageName: string
  onClickSearch: () => void
}

const Header: FC<Props> = ({ image, tableName, packageName, onClickSearch }) => {
  const { t } = useTranslation()
  const { isEnableToggleUI, serviceType, setServiceType, resetServiceType } = useServiceType()

  return isEnableToggleUI ? (
    <Wrapper>
      <BrandDetail>
        <BrandImage alt="" src={image} />
        <div>
          <WrapperTitle>
            <Fonts.H2>{tableName}</Fonts.H2>
            <PackageName>{packageName}</PackageName>
          </WrapperTitle>
          <SwitchTabsWrapper>
            <SwitchTabs
              sm
              options={[
                {
                  value: 'Buffet',
                  label: t('dineIn.services.dineIn'),
                },
                {
                  value: LineItemServiceTypeForBuffetEnum.BuffetALaCarteTakeaway,
                  label: t('dineIn.services.takeAway'),
                },
              ]}
              asyncDefaultValue={
                serviceType === LineItemServiceTypeForBuffetEnum.BuffetALaCarteTakeaway
                  ? LineItemServiceTypeForBuffetEnum.BuffetALaCarteTakeaway
                  : 'Buffet'
              }
              onChange={(val: LineItemServiceTypeForBuffetEnum) => {
                if (val === LineItemServiceTypeForBuffetEnum.BuffetALaCarteTakeaway) {
                  setServiceType(val)
                } else {
                  resetServiceType()
                }
              }}
            />
          </SwitchTabsWrapper>
        </div>
      </BrandDetail>
      <Tools style={{ alignSelf: 'flex-end' }}>
        <div onClick={onClickSearch}>
          <Icon name="search" size="20px" color={color.darkGrey} />
        </div>
        <SwitchLang theme={SwitchLangThemeTypeEnum.grey} />
      </Tools>
    </Wrapper>
  ) : (
    <Wrapper>
      <BrandDetail>
        <BrandImage alt="" src={image} />
        <div>
          <Fonts.H2>{tableName}</Fonts.H2>
          <PackageName>{packageName}</PackageName>
        </div>
      </BrandDetail>
      <Tools>
        <div onClick={onClickSearch}>
          <Icon name="search" size="20px" color={color.darkGrey} />
        </div>
        <SwitchLang theme={SwitchLangThemeTypeEnum.grey} />
      </Tools>
    </Wrapper>
  )
}

export default Header

const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 15px;
  padding-bottom: 0;
  background: ${({ theme }) => theme.colors.white};
`

const BrandDetail = styled.div`
  display: flex;
  align-items: center;
  column-gap: 8px;
`

const BrandImage = styled.img`
  width: 30px;
  height: 30px;
  border-radius: 50%;
`

const Tools = styled.div`
  display: flex;
  align-items: center;
  column-gap: 24px;
`

const PackageName = styled(Fonts.BaseTitleRegular)`
  font-size: 13px;
  color: ${({ theme }) => theme.colors.success};
`

const WrapperTitle = styled.div`
  display: flex;
  align-items: center;
  column-gap: 6px;
`

const SwitchTabsWrapper = styled.div`
  display: flex;
`
